import React, { useState } from "react";
import Box from "@mui/material/Box";
import { DataGrid } from "@mui/x-data-grid";
import Button from "@mui/material/Button";
import EditIcon from "@mui/icons-material/Edit";
import { Chip, InputAdornment, TextField } from "@mui/material";
import avatar from "../../../../../../../../../../assets/avathar.jpg";
import SearchIcon from "@mui/icons-material/Search";
import '../../serviceMan/serviceMan.css';

const ServiceManTable = ({
  serviceManList,
  onEdit,
  onLocation,
  onSuspend,
  onSelectServiceManId,
}) => {
  const [searchValue, setSearchValue] = useState("");

 const handleSearchChange = (event) => {
  setSearchValue(event.target.value.toLowerCase());
};


  const filteredServiceMan = serviceManList.filter((serviceman) =>
    Object.entries(serviceman).some(([key, value]) => {
      if (Array.isArray(value)) {
        return value.some((item) =>
          item.toString().toLowerCase().includes(searchValue)
        );
      }
      if (typeof value === "boolean") {
      
        const booleanMap = {
          is_available: value ? "online" : "offline",
          is_suspended: value ? "suspended" : "active",
        };
        return booleanMap[key]?.includes(searchValue);
      }
      return value?.toString().toLowerCase().includes(searchValue);
    })
  );
  
  

  const displayServiceMan = searchValue ? filteredServiceMan : serviceManList;

  const serviceManWithIndex = displayServiceMan.map((man, index) => ({
    ...man,
    displayIndex: index + 1,
  }));
  const columns = [
    { field: "displayIndex", headerName: "No", width: 40 },
    { field: "id", headerName: "ID", width: 90 },
    {
      field: "worker_image",
      headerName: "Photo",
      width: 100,
      renderCell: (params) => (
        <img
          src={params.value}
          alt={avatar}
          style={{
            width: "50px",
            height: "50px",
            borderRadius: "50%",
            padding: "5px",
          }}
        />
      ),
    },
    {
      field: "worker_name",
      headerName: "Technician Name",
      width: 150,
    },
    { field: "service_name", headerName: "Service", width: 220 },
    { field: "category_name", headerName: "Category", width: 150 },

    {
      field: "mobile_number",
      headerName: "Phone Number",
      width: 150,
    },
    {
      field: "is_available",
      headerName: "Current Status",
      width: 150,
      renderCell: (params) => (
        <Chip
          label={params.value ? "online" : "offline"}
          style={{
            backgroundColor: params.value ? "green" : "red",
            color: "white",
          }}
        />
      ),
    },
    { field: "address", headerName: "Address", width: 150 },
    { field: "location", headerName: "Location", width: 150 },
    { field: "district", headerName: "District", width: 150 },
    { field: "email", headerName: "Email", width: 250 },
    { field: "postal_name", headerName: "Postal Name", width: 150 },
    { field: "experience", headerName: "Experience", width: 110 },
    { field: "zipnumber", headerName: "Zip Number", width: 130 },
    {
      field: "is_suspended",
      headerName: "Suspend",
      width: 150,
      renderCell: (params) => (
        <Chip
          label={params.value ? "Suspended" : "Active"}
          style={{
            backgroundColor: params.value ? "red" : "green",
            color: "white",
          }}
        />
      ),
    },
    {
      field: "actions",
      headerName: "Actions",
      width: 250,
      renderCell: (params) => (
        <div className="action-btn">
          <Button
            variant="outlined"
            color="primary"
            style={{ marginRight: "5px" }}
            onClick={() => onEdit(params.row)}
          >
            <EditIcon />
          </Button>

          <Button
            variant="outlined"
            color="primary"
            onClick={(e) => {
              onLocation(params.row);
              onSelectServiceManId(params.row.id);
            }}
          >
            Location
          </Button>
        </div>
      ),
    },
    {
      field: "suspend",
      headerName: "Suspend",
      width: 140,
      sortable: false,
      renderCell: (params) => (
        <>
          <Button
            style={{ marginRight: "5px" }}
            variant="outlined"
            color={params.row.is_suspended ? "success" : "error"}
            onClick={(e) => {
              onSuspend(params.row);
            }}
          >
            {params.row.is_suspended ? "Active" : "Suspend"}
          </Button>
        </>
      ),
    },
  ];
  return (
    <div>
      <div className="search-container d-flex justify-content-center my-2">
        <TextField
          id="search"
          name="search"
          className="search-field"
          placeholder="Search here..."
          value={searchValue}
          onChange={handleSearchChange}
          variant="outlined"
           size="small"
           fullWidth
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
          sx={{
            "& .MuiOutlinedInput-root": {
              "& fieldset": { borderColor: "transparent" }, 
              "&:hover fieldset": { borderColor: "transparent" }, 
              "&.Mui-focused fieldset": { borderColor: "transparent" },
            },
          }}
        />
      </div>
      <Box
        sx={{
          flexGrow: 1,
          maxWidth: { xs: 650, sm: 682, lg: 1350 },
          bgcolor: "background.paper",
        }}
      >
        <DataGrid
          rows={serviceManWithIndex}
          columns={columns}
          disableSelectionOnClick
          pageSizeOptions={[25, 50, 100]}
          initialState={{
            pagination: {
              paginationModel: {
                pageSize: 25,
              },
            },
          }}
        />
      </Box>
    </div>
  );
};

export default ServiceManTable;
